const fabYouthEditorConfig = {
  initialContent: {
    hero_title: "",
    intro_section_title: "",
    intro_text: "",

    benefits_section_title: "",
    benefits_lines_text: "",
    benefits_closing_text: "",

    register_section_title: "",
    register_text: "",
  },

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
    };
  },

  buildContent(templateState = {}) {
    return {
      hero_title:
        templateState.hero_title?.trim() || "",

      intro_section_title:
        templateState.intro_section_title?.trim() || "",

      intro_text:
        templateState.intro_text?.trim() || "",

      benefits_section_title:
        templateState.benefits_section_title?.trim() || "",

      benefits_lines_text:
        templateState.benefits_lines_text?.trim() || "",

      benefits_closing_text:
        templateState.benefits_closing_text?.trim() || "",

      register_section_title:
        templateState.register_section_title?.trim() || "",

      register_text:
        templateState.register_text?.trim() || "",
    };
  },

  getStep2Props({
    templateState,
    setTemplateField,
  }) {
    return {
      templateState,
      setTemplateField,
    };
  },
};

export default fabYouthEditorConfig;